import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-tooltip', 'open', 'Ava abitekst');
Labels.set('ui-tooltip', 'close', 'Sulge abitekst');
